import Vue from 'vue';
import { MtSpinner } from '../MtSpinner';
import { remoteIcon } from '../../directives/remoteIcon';
import './MtButton.css';
export default Vue.extend({
    name: 'MtButton',
    props: {
        htmlType: {
            type: String,
            default: 'button',
            validator: function (v) {
                return ['button', 'submit', 'reset', 'menu'].indexOf(v) >= 0;
            },
        },
        disabled: {
            type: Boolean,
        },
        loading: {
            type: Boolean,
        },
        iconUrl: {
            type: String,
        },
    },
    methods: {
        generateLoader: function () {
            return this.$createElement(MtSpinner, {
                class: 'mt-button__spinner',
            });
        },
        generateIcon: function () {
            return this.$createElement('span', {
                directives: [
                    {
                        name: 'remote-icon',
                        value: this.iconUrl,
                    },
                ],
                class: {
                    'mt-button__icon': true,
                    'mt-button__hidden': this.loading,
                },
            });
        },
        generateInner: function () {
            return this.$createElement('span', {
                class: {
                    'mt-button__block': true,
                    'mt-button__hidden': this.loading,
                },
            }, [this.$slots.default]);
        },
    },
    render: function (h) {
        var icon = this.iconUrl ? this.generateIcon() : null;
        var inner = this.generateInner();
        var loader = this.loading
            ? this.$slots.loader || this.generateLoader()
            : null;
        return h('button', {
            on: this.$listeners,
            staticClass: 'mt-button',
            class: {
                'mt-button--with-icon': this.iconUrl != null,
                'mt-button--loading': this.loading,
                'mt-button--disabled': this.disabled,
            },
            attrs: {
                type: this.htmlType,
                disabled: this.disabled,
            },
        }, [icon, inner, loader]);
    },
    directives: { remoteIcon: remoteIcon },
});
//# sourceMappingURL=MtButton.js.map